/* eslint-disable no-console, no-unused-vars */
import * as CreateAccount from './modules/consumer-account/create-account';
import * as Login from './modules/consumer-account/login';

import { addTooltipsOnPageLoad } from './modules/tooltips';
import { announceMessage } from './modules/accessibility/status-messages';
import { forgotPassword } from './modules/consumer-account/account-api';
import { getLoggedInStatus, getUserId } from './modules/consumer-account/authentication';
import { getParameterByName } from './utils/url-utils';
import { validate, validateByType } from './utils/form-validation-utils';

import ContentToggle from './modules/content-toggle';
import DealerAvailabilityModal from './modules/dealer-availability-modal';
import DesktopNavMenus from './modules/desktop-nav-menus';
import FilterToggle from './modules/filter-toggle';
import GridSliders from './modules/grid-sliders';
import HeroSlider from './modules/hero-slider';
import InitMiniCart from './mini-cart';
import InPageNav from './modules/in-page-nav';
import Lazyload from './modules/lazyload';
import MinifiedHeader from './modules/minified-header';
import MobileNav from './modules/mobile-nav';
import ModalToggle from './modules/modal-toggle';
import RecentlyViewedProductsSlider from './modules/recently-viewed-products-slider';
import SiteToaster from './modules/site-toaster';
import TabRole from './modules/accessibility/tab-role';
import ToggleContentToModal from './modules/toggle-content-to-modal';

// Site vars
window.localTesting = false;
window.isAuthenticated = getLoggedInStatus();
window.userId = getUserId();
window.micrositeName = 'vitaleblinds';
window.brandId = 7;
window.jsVersion = '1.0.2';
// Console Settings
/*
console.log(`
\n\n\n*************************\n\nvitale.min.js ver: ${window.jsVersion} \n\n*************************\n
Microsite Name: ${window.micrositeName}\r
Brand Code: ${window.brandCode}\r
Brand Id: ${window.brandId}\r
Is Visualizer Active: ${window.isVisualizerActive}\r
Local Testing: ${window.localTesting}\r
Authenticated Customer: ${window.isAuthenticated}\r
User Id: ${window.userId}\n\n\n
`);
*/
const dimensions = new ToggleContentToModal({
  modalId: 'dimensions-modal',
  toggleSelector: '.btn-dimensions',
  toggleContent: [
    {
      content: '.product-dimensions-group',
      modalSelector: '#dimensions-modal .product-dimensions-wrapper',
      defaultSelector: '.product-sort-group .product-dimensions-wrapper',
    },
  ],
});
ContentToggle();
DealerAvailabilityModal({
  state: 'default',
});
DesktopNavMenus();
GridSliders();
FilterToggle();
HeroSlider();
Lazyload();
MinifiedHeader({
  headerDiv: document.querySelector('.header'),
  minClass: 'is-fixed',
});
MobileNav();
ModalToggle();
RecentlyViewedProductsSlider();
TabRole();
addTooltipsOnPageLoad();

window.Login = Login;
window.Login.init();
window.validateForm = validate;
window.validateByType = validateByType;
window.forgotPasswordSubmit = forgotPassword;
window.announceMessage = announceMessage;
window.getParameterByName = getParameterByName;

// Create Account, Modal
if (document.querySelector('.modal-acct-create-form') !== null) {
  CreateAccount.init({
    form: document.querySelector('.modal-acct-create-form'),
    disableScroll: true,
  });
}
// Create Account, In-Page
if (document.querySelector('.acct-create-form') !== null) {
  CreateAccount.init({
    form: document.querySelector('.acct-create-form'),
    disableScroll: false,
  });
}
if (document.querySelector('.in-page-nav') !== null) {
  InPageNav();
}

InitMiniCart();

// Create toaster method that can be called from inline js
window.addSiteToaster = (options) => {
  const {
    callbacks,
    id,
    message,
  } = options;
  const toaster = new SiteToaster({
    callbacks,
    id,
    message,
  });
  toaster.open();
};
/* eslint-enable no-console, no-unused-vars */
